'use memo';

import type {
  NswContractRequestModel,
  QldContractRequestModel,
  QldContractSubmissionModel,
} from '@urbanx/agx.campaigns.client';
import { AgxSpacer, AgxTypography } from '@urbanx/agx.ui-components2';
import useFormAddressSelector from 'selectors/useFormAddressSelector';
import { cleanTwoLineAddress } from 'utils/formatAddress';

type VendorDetailsDisplayValue =
  | NswContractRequestModel['vendors']
  | QldContractRequestModel['vendors']
  | QldContractSubmissionModel['vendors'];

interface VendorDetailsDisplayProps {
  defaultValue?: VendorDetailsDisplayValue;
}

const VendorDetailsDisplay = ({ defaultValue: vendorNames }: VendorDetailsDisplayProps) => {
  const address = useFormAddressSelector();
  const [addressLineOne, addressLineTwo] = cleanTwoLineAddress(address ?? null);
  const vendorNamesDisplayText = vendorNames?.join(', ') ?? '';

  return (
    <AgxSpacer direction="vertical" gap="spacing-xl" fill>
      <AgxSpacer direction="vertical" gap="spacing-md" fill>
        <AgxTypography id="vendor-details-display-property-address-label" type="label" size="large">
          Property Address
        </AgxTypography>
        <AgxTypography id="vendor-details-display-property-address" type="body_ui" size="medium">
          {addressLineOne}
          <br />
          {addressLineTwo}
        </AgxTypography>
      </AgxSpacer>
      <AgxSpacer direction="vertical" gap="spacing-md" fill>
        <AgxTypography id="vendor-details-display-vendors-label" type="label" size="large">
          Vendors
        </AgxTypography>
        <AgxTypography id="vendor-details-display-vendors" type="body_ui" size="medium">
          {vendorNamesDisplayText}
        </AgxTypography>
      </AgxSpacer>
    </AgxSpacer>
  );
};

export default VendorDetailsDisplay;
